



















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import StatisticalItem from './StatisticalItem.vue'
import { RegenerateFinanceBizReconcileStat } from '@/api'

interface DayPairMap {
  today: Record<string, unknown>
  yesterday: Record<string, unknown>
}

interface ReconcilePanelData {
  allocateRechargeMap?: DayPairMap
  specialPriceMap?: DayPairMap
  distributionMap?: DayPairMap
  bizPvReconcileMap?: DayPairMap
}

function formatYmd(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function normalizeYmd(raw: string): string {
  const parts = raw.split('-')
  if (parts.length !== 3) {
    return raw
  }
  const y = parts[0]
  const m = parts[1].padStart(2, '0')
  const d = parts[2].padStart(2, '0')
  return `${y}-${m}-${d}`
}

function todayStr(): string {
  return formatYmd(new Date())
}

function marchFirstStr(): string {
  const y = new Date().getFullYear()
  return `${y}-03-01`
}

function emptyDayPair(): DayPairMap {
  return { today: {}, yesterday: {} }
}

@Component({
  components: { StatisticalItem },
})
export default class FinanceBizReconcilePanel extends Vue {
  @Prop({ required: true }) data!: ReconcilePanelData

  private regenerating = false
  private regenerateRange: string[] = [marchFirstStr(), todayStr()]
  private pickerOptions = {
    disabledDate(time: Date): boolean {
      return time.getTime() > Date.now()
    },
  }

  private get a(): DayPairMap {
    return this.data.allocateRechargeMap || emptyDayPair()
  }

  private get s(): DayPairMap {
    return this.data.specialPriceMap || emptyDayPair()
  }

  private get d(): DayPairMap {
    return this.data.distributionMap || emptyDayPair()
  }

  private get b(): DayPairMap {
    return this.data.bizPvReconcileMap || emptyDayPair()
  }

  private get defaultRangeHint(): string {
    return `${marchFirstStr()} 至 ${todayStr()}`
  }

  private onConfirmCancelled(): void {
    // 用户取消确认框
  }

  public handleRegenerate(): void {
    if (!this.regenerateRange || this.regenerateRange.length !== 2) {
      this.$message.warning('请选择日期范围')
      return
    }
    const [startRaw, endRaw] = this.regenerateRange
    const startDate = normalizeYmd(startRaw)
    const endDate = normalizeYmd(endRaw)
    const dayMs = 86400000
    const days = Math.floor((new Date(endDate).getTime() - new Date(startDate).getTime()) / dayMs) + 1
    this.$confirm(
      `将补跑 ${startDate} 至 ${endDate} 共 ${days} 天的业务对账日汇总（按日覆盖更新），耗时可能较长，是否继续？`,
      '批量生成历史数据',
      { type: 'warning', confirmButtonText: '开始生成', cancelButtonText: '取消' }
    ).then(() => {
      this.regenerating = true
      RegenerateFinanceBizReconcileStat({ startDate, endDate })
        .then(() => {
          this.$message.success('历史数据生成完成')
          this.$emit('refresh')
        })
        .finally(() => {
          this.regenerating = false
        })
    }).catch(this.onConfirmCancelled)
  }
}
